import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { graph } from '@adc/constants';
const FORECLOSURE_PRODUCT_TYPES = new Set([
    graph.enums.ProductType.TRUSTEE,
    graph.enums.ProductType.FCL_MARKETING,
]);
const ListingReserve = ({ listing, elmId }) => {
    const [reserveLabel, reserveValue] = ListingReserve.rawTuple(listing);
    return (_jsxs("div", { "data-elm-id": `reserve_amount_${elmId}`, children: [_jsxs("label", { children: [reserveLabel, ":"] }), _jsx("span", { children: reserveValue })] }));
};
ListingReserve.rawTuple = (listing, emptyValue = '', callerReserveOverride = null) => {
    const mostAccurateReserveValueAvailable = callerReserveOverride || listing.reserve_price;
    const value = mostAccurateReserveValueAvailable
        ? numeral(mostAccurateReserveValueAvailable).format('$0,0')
        : emptyValue;
    const label = FORECLOSURE_PRODUCT_TYPES.has(listing.listing_configuration?.product_type)
        ? 'Est. Credit Bid'
        : 'Reserve Amount';
    return [label, value];
};
ListingReserve.propTypes = {
    listing: PropTypes.object.isRequired,
    elmId: PropTypes.string.isRequired,
};
export default ListingReserve;
//# sourceMappingURL=index.js.map